import { render, staticRenderFns } from "./AllTasks.vue?vue&type=template&id=2c34cad1&scoped=true"
import script from "./AllTasks.vue?vue&type=script&lang=js"
export * from "./AllTasks.vue?vue&type=script&lang=js"
import style0 from "./AllTasks.vue?vue&type=style&index=0&id=2c34cad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34cad1",
  null
  
)

export default component.exports